import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { IQuestion, IQuestionOptions } from '../../interfaces';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { Checkbox, FormHelperText, FormLabel, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { useState } from 'react';
import RenderQuestion from '../RenderQuestion';
import {nanoid} from "nanoid";
import { Close } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import { useApp } from '../../Contexts/AppProvider';

interface IProps extends IQuestion {
  selectProps?: Partial<SelectInputProps & {placeholder: string}>
}

export default function QuestionMultiselectInput({
  index,
  question,
  type,
  options,
  fieldNameVoucher,
  mask,
  description,
  defaultValue,
  hasTree,
  selectProps
}: IProps) {
  const {onSetCurrentQuestions} = useApp();
  const { control, setValue, clearErrors } = useFormContext();
  const [otherQuestions, setOtherQuestions] = useState<IQuestion[]>([]);

  const keySelect = nanoid();

  React.useEffect(() => {
    onSetCurrentQuestions({
      index,
      question,
      type,
      options,
      fieldNameVoucher,
      mask,
      description,
      defaultValue,
      hasTree,
    });

    return () => {
      onSetCurrentQuestions({
        index,
        question,
        type,
        options,
        fieldNameVoucher,
        mask,
        description,
        defaultValue,
        hasTree,
      }, true);
    }
  }, [
    defaultValue,
    description,
    hasTree,
    index,
    mask,
    onSetCurrentQuestions,
    options,
    question,
    type,
    fieldNameVoucher
  ])

  return (
    <>
      <Controller
        name={index.toString()}
        control={control}
        defaultValue={[]}
        render={({ field: {value, name, ref}, formState: {errors} }) => {
          return (
            <FormControl
              sx={{mt: 1, mb: 2}}
              fullWidth
              error={!!errors[index.toString()]?.message}
              focused={!!errors[index.toString()]?.message}
            >
              <FormLabel id={`${keySelect}-select-label`}>{question} (pode selecionar mais de uma opção)</FormLabel>
              <Select
                required
                multiple
                displayEmpty
                sx={{mt: 1}}
                ref={ref}
                name={name}
                value={value}
                labelId={`${keySelect}-select-label`}
                id={`${keySelect}-select`}
                onChange={(e, _) => {
                  clearErrors(index.toString());
                  setValue(
                    index.toString(),
                    typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value
                  );

                  const optSelecteds = options?.filter((opt: IQuestionOptions) => e.target.value?.includes(opt.value) && opt?.tree);

                  const questionsConcat: IQuestion[] = [];
                  optSelecteds?.map((optSelected) => {
                    optSelected?.questions?.map((question) => questionsConcat.push(question));
                    return optSelected;
                  })

                  setOtherQuestions(questionsConcat);

                  selectProps?.onChange && selectProps?.onChange(e, _);
                }}
                input={
                  <OutlinedInput endAdornment={
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="toggle password visibility"
                        disabled={value.length === 0}
                        onClick={() => {
                          clearErrors(index.toString());
                          setValue(index?.toString(), []);
                          setOtherQuestions([]);
                        }}
                        edge="start"
                      >
                        {<Close />}
                      </IconButton>
                    </InputAdornment>
                  }/>
                }
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <em style={{color: '#999'}}>Selecionar</em>;
                  }
                  return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected?.map((value: any) => (
                        <Chip variant="outlined" key={value} label={value} color="primary" />
                      ))}
                    </Box>
                  )
                }}
              >
                <MenuItem value={[]} disabled={true}>
                  <em style={{color: '#999'}}>{selectProps?.placeholder || 'Selecionar'}</em>
                </MenuItem>
                {options?.map((option) => {
                  const keyOptions = nanoid();
                  return (
                    <MenuItem key={`${keyOptions}-select-options`} value={option?.value}>
                      <Checkbox checked={value.indexOf(option?.value) > -1} />
                      {option?.value}
                    </MenuItem>
                  )
                })}
              </Select>
              {(description || errors[index.toString()]?.message) && (
                <FormHelperText>{description || errors[index.toString()]?.message as string}</FormHelperText>
              )}
            </FormControl>
          )
        }}
      />
      {otherQuestions?.map((props) => <RenderQuestion key={props?.index?.toString()} {...props} />)}
    </>
  );
}